'use client'
/**
 * Represents the value that separates the random string from the
 * mobile deeplink URL in the state param from the oauth messages
 * emitted from native mobile apps.
 */
const nativeMobileOauthStateParam = '_client-redirect:';

export { nativeMobileOauthStateParam };
